import * as React from 'react'

import { TabsContext } from '../tabsContext'

import * as styles from './tab.module.css'

interface IProps {
  value: string
  children: React.ReactNode
}

const Tab = ({ value, children }: IProps) => (
  <TabsContext.Consumer>
    {({ tabsValue, onChange }) => {
      const isActive = tabsValue === value
      const activeStyle = isActive ? styles.active : ''
      return (
        <button
          onClick={() => onChange(value)}
          className={`${styles.root} ${activeStyle}`}
          role="tab"
          aria-selected={isActive}
        >
          {children}
        </button>
      )
    }}
  </TabsContext.Consumer>
)

export default Tab
